import React, { Component } from 'react';
import { connect } from 'react-redux';
import { do_action } from '../../actions';
import {getFloor, convertPrice, formartDate, calculatorPriceItem, convertPriceNumber} from '../../utils/convert'
import {BASE_URL_ADMIN} from '../../data/config'

class PaymentTerm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            price: 0,
            payments: [],
            quotes: ''
        }
    }

    setPaymentList = (data) => {
        let [
            quotes,
            payments,
            price
        ] = data;

        this.setState({
            payments,
            price,
            quotes
        })
    }

    componentWillMount = () => {
        if (this.props.vendor._id) {
            do_action('get_payment_detail', {
                vendor: this.props.vendor._id,
                quotes: this.props.match.params.project,
                type: this.props.vendor.type
            })
                .then(data => {
                    if (data.signal) this.setPaymentList(data.data);
                })
                .catch(err => console.log(err));
        }
    }

    componentWillReceiveProps = (nextProps) => {
        if (this.props.vendor !== nextProps.vendor) {
            do_action('get_payment_detail', {
                vendor: nextProps.vendor._id,
                type: nextProps.vendor.type,
                quotes: this.props.match.params.project
            })
                .then(data => {
                    if (data.signal) this.setPaymentList(data.data);
                })
                .catch(err => console.log(err));
        }
    }

    renderPaymentTerms = () => {
        if (!this.state.payments.length) return (
            <div className="row text-center bg-white">
                <h4>You don't have any payment term in this quote</h4>
            </div>
        )
        
        let content = this.state.payments.map((item, index) => {
            return (
                <tr key={`quotes-${index}`}>
                    <td className="w-10">{item.percent}%</td>
                    <td className="w-20">{item.stage}</td>
                    <td className="text-primary-kt fontSemiBold w-20">{`$${convertPriceNumber(item.amount)}`}</td>
                    <td className="text-primary-kt fontSemiBold w-20">{`$${convertPriceNumber(item.client_paid)}`}</td>
                    <td className="w-15">{item.reciept}</td>
                    <td className="w-15">{item.bond}</td>
                </tr>
            )
        })

        return (
            <div className="form-group table-responsive table-kt">
                <table className="table">
                    <thead>
                        <tr>
                            <th className="w-10">
                                100%    
                            </th>
                            <th className="w-20">
                                Stage    
                            </th>
                            <th className="w-20">
                                Amount    
                            </th>
                            <th className="w-20">
                                Client Paid    
                            </th>
                            <th className="w-15">
                                Reciept    
                            </th>
                            <th className="w-15">
                                Bond    
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {content}
                    </tbody>
                </table>
            </div>
        )
    }

    downloadImage(allImage) {
        allImage.forEach((url, idx) => {
            window.downloadImage(url, idx)
        })
    }

    renderThumbnail = (source) => {
        let numberImage = source.length
        return source.map((item, idx) => {
            if (idx < numberImage - 1) {
                return <li key={`image_${item}`}><a><img className="thumbnail-quote" src={`${item}`} alt="" /></a></li>
            } else {
                return (
                    <li key={`image_${item}`}>
                        <a href="#"><img className="thumbnail-quote" src={`${item}`} alt="" /></a>
                        <div className="last-down" onClick={this.downloadImage.bind(this, source)}>
                            <div><span className="fa fa-cloud-download icon"></span></div>
                            Download All
                        </div>
                    </li>
                )
            }
        })
    }

    printQuotes(e) {
        e.preventDefault()
        let {vendor} = this.props
        let { quotes } = this.state;
        if (vendor.type == 'contractor') {
            window.open(`${BASE_URL_ADMIN}/api/pdf/vendor/print?quote=${quotes._id}&vendor=${vendor._id}`, '_blank')
        } else if (vendor.type == 'designer') {
            window.open(`${BASE_URL_ADMIN}/api/pdf/designer/print?quote=${quotes._id}&vendor=${vendor._id}`, '_blank')
        } else {
            window.open(`${BASE_URL_ADMIN}/api/pdf/pm/print?quote=${quotes._id}&vendor=${vendor._id}`, '_blank')
        }
    }

    downloadQuotes(e) {
        e.preventDefault()
        let { quotes } = this.state;
        let {vendor} = this.props
        if (vendor.type == 'contractor') {
            window.open(`${BASE_URL_ADMIN}/api/pdf/download?quote=${quotes._id}&vendor=${vendor._id}`, '_blank')
        } else if (vendor.type == 'designer') {
            window.open(`${BASE_URL_ADMIN}/api/pdf/designer/download?quote=${quotes._id}&vendor=${vendor._id}`, '_blank')
        } else {
            window.open(`${BASE_URL_ADMIN}/api/pdf/pm/download?quote=${quotes._id}&vendor=${vendor._id}`, '_blank')
        }
    }

    renderQuoteImage() {
        let { quotes } = this.state;
        if (!quotes) return '';
        return (
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4">
                <div className="side-a">
                    <div className="title">Action</div>
                    <ul className="list-inline list-img list-download">
                        {this.renderThumbnail(quotes.image)}
                    </ul>
                    <ul className="list-unstyled list-info">
                        <li className="clearfix">
                            <span className="info-name">House type</span>
                            <span className="info-value">{quotes.house_type}</span>
                        </li>
                        <li className="clearfix">
                            <span className="info-name">Area</span>
                            <span className="info-value">{quotes.areas}</span>
                        </li>
                        <li className="clearfix">
                            <span className="info-name">New or resale</span>
                            <span className="info-value">{quotes.state}</span>
                        </li>
                        <li className="clearfix">
                            <span className="info-name">Expected date</span>
                            <span className="info-value">{formartDate(quotes.expected_date)}</span>
                        </li>
                        <li className="clearfix">
                            <span className="info-name">Total price</span>
                            <span className="info-value">${convertPriceNumber(this.state.price)}</span>
                        </li>
                    </ul>
                    <div className="continue-border">
                        <div className="clearfix group2a">
                            <a href="#" className="left" onClick={this.downloadQuotes.bind(this)}>
                                <span className="fa fa-cloud-download "></span>
                            </a>
                            <a href="#" className="right" onClick={this.printQuotes.bind(this)}>
                                <span className="fa fa-print"></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 maindb">
                <div className="form-group clearfix">
                    <div className="pull-left">
                        <h3 className="marginT0">Payment term</h3>
                    </div>
                </div>
                <div className="form-group">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-7 col-lg-8">
                            
                            {this.renderPaymentTerms()}

                        </div>

                        {this.renderQuoteImage()}

                    </div>
                </div>
            </div>

        );
    }
}


function mapStateToProps(state) {
    const { vendor } = state;
    return {
        vendor
    }
}

export default connect(mapStateToProps)(PaymentTerm);